import lodashThrottle from "lodash/throttle";
import PropTypes from "prop-types";
import React, { Component } from "react";

class ScrollMonitor extends Component {
  changeList = React.createRef();

  constructor(props) {
    super(props);
    const { onScroll, throttle } = this.props;
    this.throttleOnScroll = lodashThrottle(onScroll, throttle);
  }

  componentDidMount() {
    this.changeList.current.addEventListener("scroll", this.throttleOnScroll);
  }

  componentWillUnmount() {
    this.changeList.current.removeEventListener(
      "scroll",
      this.throttleOnScroll
    );
  }

  render() {
    const { children, onScroll, throttle, ...other } = this.props;
    return (
      <div ref={this.changeList} {...other}>
        {children}
      </div>
    );
  }
}

ScrollMonitor.propTypes = {
  children: PropTypes.node.isRequired,
  onScroll: PropTypes.func.isRequired,
  throttle: PropTypes.number
};

ScrollMonitor.defaultProps = {
  throttle: 100
};

export default ScrollMonitor;
